import ThreeDotsIcon from '@/assets/three-dots.svg?react'
import ActionButton, { type ActionButtonProps } from '@/components/ActionButton'
import DropdownMenu, { DropdownMenuProps } from '@/components/DropdownMenu/DropdownMenu'
import styles from './MoreMenuButton.module.css'

export interface MoreMenuButtonProps extends Omit<DropdownMenuProps, 'renderTrigger'> {}

export default function MoreMenuButton({ ...props }: MoreMenuButtonProps) {
	return (
		<DropdownMenu
			position="top-end"
			renderTrigger={(props) => (
				<ActionButton
					tooltip="更多操作"
					icon={<ThreeDotsIcon width="20px" height="20px" className={styles.icon} />}
					{...(props as ActionButtonProps)}
				/>
			)}
			{...props}
		/>
	)
}
